import api from "./axiosInstance";

export const fetchPaymentHistoryApi = async (attendeeId: number) =>
  api.get(`/payment-history/${attendeeId}`);
